import { ReactionUserViewFragmentFragment } from "src/api/graphql/__generated__/graphql";
import { useClientId } from "src/helpers/globalHelpers";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { Image, Link, Text } from "src/swsh-native";

const ProfilePictureSize = 72;
const ReactionUserItem = ({ reactionUser }: { reactionUser: ReactionUserViewFragmentFragment }) => {
	const clientId = useClientId();
	if (!reactionUser.user) return null;

	const pfpUrl = reactionUser.user.profilePicture?.url;
	return (
		<Link
			testID="ReactionUserItem"
			href={`/user_/${reactionUser.user.userId}`}
			style={{
				alignItems: "center",
				marginVertical: paddingLarge,
				width: "100%",
				rowGap: paddingMedium,
			}}
		>
			{pfpUrl && (
				<Image
					alt="Profile Picture"
					src={pfpUrl}
					dim={{
						width: ProfilePictureSize,
						height: ProfilePictureSize,
					}}
					style={{
						borderRadius: ProfilePictureSize / 2,
					}}
				/>
			)}
			<Text small semibold>
				{clientId === reactionUser.user.userId ? "You" : reactionUser.user.firstName}
			</Text>
		</Link>
	);
};
export default ReactionUserItem;
